<apex-profile-form [hideSettings]="true"></apex-profile-form>
